export const CREATE_NOTE = 'CREATE_NOTE';
export const UPDATE_NOTE = 'UPDATE_NOTE';
export const DELETE_NOTE = 'DELETE_NOTE';



/** WEBPACK FOOTER **
 ** ./app/constants/NoteActionTypes.js
 **/